<template>
  <v-container fluid pa-0 ma-0 fill-height style="background-color: white;">
    <v-layout column wrap fill-height justify-space-between class="ma-0 pa-4 pt-5">

      <v-toolbar class="pa-0 ma-0 toolbar-padding"
                 color="white" flat dense fixed app>
        <v-btn small flat icon @click="$router.go(-1)">
          <v-icon size="24px">$vuetify.icons.navArrowLeft</v-icon>
        </v-btn>
        <h3 class="display-2" style="margin-bottom: 2px">비밀번호 재설정</h3>
      </v-toolbar>

      <div class="pt-5 px-3 autocomplete-color">
        <div class="pb-4">비밀번호를 재설정하려는 계정의<br>이메일을 입력하세요.</div>
        <v-form v-model="isValid" ref="form">
          <v-text-field v-model="email"
                        :rules="emailRules"
                        required
                        label="Email"
                        placeholder="이메일"
                        type="email">
          </v-text-field>
        </v-form>
      </div>

      <div class="px-3">
        <v-btn :disabled="!isValid"
               :loading="loading"
               block depressed color="#4a4a4a"
               class="button-style"
               style="color: white !important;"
               @click="submit">
          확인
        </v-btn>
      </div>

    </v-layout>

    <v-snackbar v-model="snackbar" bottom vertical :timeout="3000" auto-height>
      {{ errorMessage }}
      <v-btn color="primary" flat @click="snackbar = false">닫기</v-btn>
    </v-snackbar>

  </v-container>
</template>

<script>
  import firebase from 'firebase/app';
  import 'firebase/auth';
  import { mapActions } from 'vuex';

  export default {
    name: 'ResetPassword',
    computed: {
      emailRules () {
        return [
          v => !!v || '이메일을 입력하세요.',
          v => /.+@.+/.test(v) || '유효하지 않은 메일 주소입니다.',
          v => !!v && this.existEmail || '존재하지 않는 계정입니다.',
        ];
      }
    },
    data () {
      return {
        isValid: false,
        email: '',
        existEmail: true,
        loading: false,
        errorMessage: '',
        snackbar: false,
      };
    },
    methods: {
      ...mapActions('user', [ 'checkUserEmail' ]),
      submit () {
        this.loading = true;
        let root = this;
        this.checkUserEmail(this.email).then(response => {
          if (response.data) {
            firebase.auth().sendPasswordResetEmail(root.email).then(() => {
              root.$router.replace({ name: 'ResetConfirm' });
              root.loading = false;
            }).catch(error => {
              console.error(error);
              root.showErrorSnackbar('오류가 발생했습니다. 잠시 후 다시 시도해보세요.');
              root.loading = false;
            });
          } else {
            this.existEmail = false;
            this.$refs.form.validate();
            this.loading = false;
            return false;
          }
        }).catch(err => {
          console.error(err);
          root.showErrorSnackbar('오류가 발생했습니다. 잠시 후 다시 시도해보세요.');
          this.loading = false;
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .button-style {
    height: 56px;
    font-size: 14px;
    letter-spacing: -0.3px;
  }
</style>
